import { Component, Input, OnInit } from '@angular/core';
import { FormControl } from '@angular/forms';
import { BaseAccordionComponent } from '../base-accordion.component';

@Component({
  selector: 'app-visit-last-visit-summary',
  templateUrl: './visit-last-visit-summary.component.html',
  styleUrls: ['./visit-last-visit-summary.component.scss'],
})
export class VisitLastVisitSummaryComponent
  extends BaseAccordionComponent
  implements OnInit
{
  @Input() visit;
  @Input() scoreStatuses: any;
  public selectedVisit: any;
  public lastVisitControl = new FormControl();
  public lastVisitOptions: any[] = [];

  ngOnInit() {
    super.ngOnInit();

    if (this.visit.lastVisits?.length > 0) {
      this.selectedVisit = this.visit.lastVisits[0];
      this.lastVisitOptions = this.visit.lastVisits.map((visit: any) => {
        const date = new Date(visit.completedOn);
        const day = date.getDate().toString().padStart(2, '0');
        const month = date.toLocaleString('en-US', { month: 'short' });
        const year = date.getFullYear();
        const dateStr = `${day} ${month} ${year}`;
        return {
          value: visit,
          label: `${visit.visitType} - ${dateStr}`,
          scoreStatus: visit.scoreStatus,
        };
      });
      this.lastVisitControl.setValue(this.selectedVisit);
      this.selectedVisit.score = this.getScoreStatus(
        this.selectedVisit.scoreStatus
      )?.label;
    }

    this.lastVisitControl.valueChanges.subscribe((value) => {
      this.selectedVisit = value;

      this.selectedVisit.score = this.getScoreStatus(
        this.selectedVisit.scoreStatus
      ).label;
    });
  }

  getScoreStatus(score: number) {
    return this.scoreStatuses.find(
      (status: any) => status.value === score?.toString()
    );
  }
}
